export * from './PrivateCertificateContent';
